import { postCampaignEmail } from '../services/postCampaignEmail';
export const submitCampaign = (payload) => postCampaignEmail(payload);
